import React, { useState, useEffect } from "react";
import { useAuthCheck } from "../components/Auth";
import { api } from "../components/Api";
import { useNavigate } from "react-router-dom";

export default function AddUser() {
    const navigate = useNavigate();
    const [form, setForm] = useState({ name: "", email: "" });
    const [loading, setLoading] = useState(false);
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const generatePassword = () => {
        return Math.random().toString(36).slice(-10); // mot de passe aléatoire de 10 caractères
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.email) return alert("Tous les champs sont obligatoires.");

        const password = generatePassword();

        setLoading(true);
        try {
            // Création de l'utilisateur
            await api.post("/register", {
                name: form.name,
                email: form.email,
                password,
                password_confirmation: password,
            });

            // Envoi du mail "forgot password"
            await api.post("/forgot-password", { email: form.email });

            alert("Utilisateur créé et email de changement de mot de passe envoyé !");
            setForm({ name: "", email: "" });
        } catch (err) {
            console.error(err);
            if (err.response?.data?.errors) {
                alert(Object.values(err.response.data.errors).flat().join("\n"));
            } else {
                alert("Erreur lors de la création de l'utilisateur.");
            }
        } finally {
            setLoading(false);
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    return (
        <div className="container mx-auto p-6 max-w-md">
            <h1 className="text-2xl font-bold mb-4 dark:text-white">Ajouter un utilisateur</h1>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block mb-1 font-medium">Nom</label>
                    <input
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        className="w-full border p-2 rounded dark:bg-gray-700 bg-white"
                        required
                    />
                </div>

                <div>
                    <label className="block mb-1 font-medium">Email</label>
                    <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        className="w-full border p-2 rounded dark:bg-gray-700 bg-white"
                        required
                    />
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                    {loading ? "Création..." : "Créer"}
                </button>
            </form>
        </div>
    );
}
